import {IEnvironment} from '../app/1-application/types'

export const environment: IEnvironment = {
  apiUrl: 'https://api-landing-be-test.akiru.se/api'
}